import { render, staticRenderFns } from "./_workshop_list.vue?vue&type=template&id=116046a6&"
import script from "./_workshop_list.vue?vue&type=script&lang=js&"
export * from "./_workshop_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports